import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, ProjectStatus } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  statuses: Identifiable<ProjectStatus>[];
  retrieveProjectStatuses(
    request: Boundaries["retrieveProjectStatuses"]["request"],
  ): void;
}

function useProjectStatusesRetrieval(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isProjectStatusesRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isProjectStatusesRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isProjectStatusesRetrievalRequestFailure,
    ),
    statuses: useSelector(selector.getProjectStatuses),
    retrieveProjectStatuses: core.retrieveProjectStatuses,
  };
}

export { useProjectStatusesRetrieval };
